import React from 'react';
import { Link } from 'react-router';

import Tabs from '../common/Tabs';
import RemoteApps from './RemoteApps';
import FeatureFlagOverrides from './FeatureFlagOverrides';
import Test from './Test';
import config from '../../config';

const AppSettings = props => (
  <div className="c-wrapper">
    <div className="u-color-white u-margin-auto u-max-width-710">
      <div className="layout c-wrapper u-pb0">
        <div className="layout__item u-1/3">
          <div className="c-heading c-heading--dark">App settings</div>
        </div>
      </div>
      <Tabs active={props.activeTab}>
        <Tabs.Tab title="Flags" onTabClick={() => () => props.setActiveTab(0)}>
          <FeatureFlagOverrides />
        </Tabs.Tab>
        <Tabs.Tab title="Remotes" onTabClick={() => () => props.openRemotes()}>
          <RemoteApps />
        </Tabs.Tab>
        <Tabs.Tab
          title="Test"
          onTabClick={() => () => props.setActiveTab(2)}
          display-if={!['demo', 'production'].includes(config.deploymentEnv)}
        >
          <Test />
        </Tabs.Tab>
      </Tabs>
      <div className="layout u-mt+">
        <div className="layout__item u-1/2 u-pl+">
          <Link to="/" className="c-btn">Back to app</Link>
        </div>
      </div>
    </div>
  </div>
);

export default AppSettings;
